import React, { createContext, useContext, useState, useEffect } from 'react';
const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [role, setRole] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedRole = localStorage.getItem('role');
    if (storedRole && role !== storedRole) {
      setRole(storedRole);
    }
    setIsLoading(false);
  }, [role]);

  return (
    <AuthContext.Provider value={{ role, setRole, isLoading }}>
      {!isLoading ? children : ""}
    </AuthContext.Provider>
  );
};
